import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import PrimaryTheme from "../Themes/Primary";
import Input from "./Input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Reducers } from "../Interfaces/Interfaces";
import StatusAlert from "./StatusAlert";
import { getCashoutAccount } from "../redux/actions/userActions";
import { getCoordinatorCashoutAccount } from "../redux/actions/CoordinatorActions";
import SetUpCashoutAccount from "./SetUpCashoutAccount";

export default function CashoutAccount() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const cashout = useSelector((state: Reducers) => state.cashout);
  const userType = useSelector((state: Reducers) => state.userType);
  // const coordinatorType = useSelector((state: Reducers) => state.coordinatorType);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [bankName, setBankName] = React.useState("");
  const [agentName, setAgentName] = React.useState("");
  const [agentPhoneNumber, setAgentPhoneNumber] = React.useState("");
  const [accountNumber, setAccountNumber] = React.useState("");
  const [accountName, setAccountName] = React.useState("");
  const [submitted, setSubmitted]: any = React.useState(false);
  const [hasCashoutAccount, setCashout] = React.useState(false);
  const [hasSetupAgentAccount, setAgentAccount] = React.useState(false);

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });

    setSubmitted(false);
    setBankName("");
    setAccountNumber("");
    setAccountName("");

    if (userType === "5") {
      dispatch(getCashoutAccount(user.id));
    } else {
      dispatch(getCoordinatorCashoutAccount(user.id));
    }
  };

  // const handleCashout= () => {
  //   if (Object.entries(cashout).length !== 0) {
  //     setBankName(cashout.bankName);
  //     setAgentName(cashout.agentName);
  //     setAgentPhoneNumber(cashout.agentPhoneNumber);
  //     setAccountNumber(cashout.accountNumber);
  //     setAccountName(cashout.accountName);
  //     setCashout(true);
  //     setAgentAccount(true);
  //   } else {
  //     setCashout(false);
  //     setAgentAccount(false);
  //   }
  // }

  React.useEffect(() => {
    if (
      cashout &&
      cashout.hasCashoutAccount &&
      Object.entries(cashout).length !== 0
    ) {
      setBankName(cashout.bankName);
      setAgentName(cashout.agentName);
      setAgentPhoneNumber(cashout.agentPhoneNumber);
      setAccountNumber(cashout.accountNumber);
      setAccountName(cashout.accountName);
      setCashout(true);
      setAgentAccount(true);
    } else {
      setCashout(false);
      setAgentAccount(false);
    }
  }, [cashout]);

  const goBack = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    history.push("/dashboard");
  };

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        // enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        setSubmitted(false);
      } else {
        enqueueSnackbar(alert.message, { variant: "success" });
        // handleRefresh();

        dispatch({
          type: "STATUS_ALERT",
          payload: true,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  // console.log({ agentName})
  return (
    <div className="col-md-12 modal-container">
      <DialogContent>
        {hasCashoutAccount && (
          <React.Fragment>
            <h5 className="mb-3 text-bold">Cashout Account Information</h5>

            <div className="col-md-12 p-0">
              <label
                htmlFor="bankName"
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                  fontSize: PrimaryTheme.fontSizes?.small,
                  textTransform: "uppercase",
                }}
              >
                Bank Name
              </label>

              <Input
                type={"text"}
                inputMode="text"
                isInput
                disabled
                id="bankName"
                placeholder="Bank Name"
                value={bankName}
                onChange={(e) => setBankName(e.target.value)}
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  backgroundColor: PrimaryTheme.background,
                  color: PrimaryTheme.dark,
                }}
              />
            </div>

            <div className="col-md-12 p-0">
              <label
                htmlFor="accountNumber"
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                  fontSize: PrimaryTheme.fontSizes?.small,
                  textTransform: "uppercase",
                }}
              >
                Account Number
              </label>

              <Input
                type={"text"}
                inputMode="text"
                isInput
                disabled
                id="accountNumber"
                value={accountNumber}
                maxLength={4}
                onChange={(e) => setAccountNumber(e.target.value)}
                placeholder="Account Number"
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  backgroundColor: PrimaryTheme.background,
                  color: PrimaryTheme.dark,
                }}
              />
            </div>

            <div className="col-md-12 p-0">
              <label
                htmlFor="accountName"
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                  fontSize: PrimaryTheme.fontSizes?.small,
                  textTransform: "uppercase",
                }}
              >
                Account Name
              </label>

              <Input
                type={"text"}
                inputMode="text"
                isInput
                disabled
                id="accountName"
                placeholder="Account Name"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  backgroundColor: PrimaryTheme.background,
                  color: PrimaryTheme.dark,
                  padding: "1.1rem",
                  borderRadius: 100,
                }}
              />
            </div>
          </React.Fragment>
        )}

        {/* setup cashout account */}
        {!hasCashoutAccount && <SetUpCashoutAccount />}

        {hasSetupAgentAccount && (
          <React.Fragment>
            <h5 className="mb-3 text-bold mt-5">Agent Account Information</h5>

            <div className="col-md-12 p-0">
              <label
                htmlFor="agentName"
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                  fontSize: PrimaryTheme.fontSizes?.small,
                  textTransform: "uppercase",
                }}
              >
                Agent Name
              </label>

              <Input
                type={"text"}
                inputMode="text"
                isInput
                disabled
                id="agentName"
                placeholder="Agent Name"
                value={agentName}
                onChange={(e) => setAgentName(e.target.value)}
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  backgroundColor: PrimaryTheme.background,
                  color: PrimaryTheme.dark,
                }}
              />
            </div>

            <div className="col-md-12 p-0">
              <label
                htmlFor="agentPhoneNumber"
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                  fontSize: PrimaryTheme.fontSizes?.small,
                  textTransform: "uppercase",
                }}
              >
                Agent Phone Number
              </label>

              <Input
                type={"text"}
                inputMode="text"
                isInput
                disabled
                id="agentPhoneNumber"
                placeholder="Agent Phone number"
                value={agentPhoneNumber}
                onChange={(e) => setAgentPhoneNumber(e.target.value)}
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  backgroundColor: PrimaryTheme.background,
                  color: PrimaryTheme.dark,
                }}
              />
            </div>
          </React.Fragment>
        )}
      </DialogContent>

      {/* <DialogActions>
        <div className="col-md-8 ml-auto mr-auto mb-0 text-center">

          <Input
            type="button"
            isInput
            id="confirm-password"
            value={submitted ? "Changing..." : "Change PIN"}
            disabled={submitted ||
              bankName === "" ||
              accountNumber === "" ||
              accountName === ""
            }
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikBold,
              backgroundColor: PrimaryTheme.primary,
              color: PrimaryTheme.white,
              padding: '1.1rem',
              borderRadius: 100
            }}
            onClick={handleSubmit}
          />

        </div>
      </DialogActions> */}

      <StatusAlert
        title={"Cashout account set Successfully"}
        // subtitle={"Your cashout account has been set successfully."}
        buttonTitle="Done"
        backTitle="Back to dashboard"
        goBack={goBack}
        onClick={handleRefresh}
      ></StatusAlert>
    </div>
  );
}
